import { useDispatch, useSelector } from 'react-redux'

import Grid from '@mui/material/Grid'


import { AppDispatch, RootState } from 'redux/store'
import { setSubject, setCategory, setGradeLevel, setGroup, setStudent, 
  setCreatedAfter, setCreatedBefore, trackActiveFilters,} from 'redux/ui/kpiEvaluationsUI'

import SelectField from 'components/atoms/fields/SelectField'

import formModel from 'utils/tableFilterModels/benchmarksTableFilterModel'
import { useGET_subjectsSelectQuery } from 'redux/api/subjectsApi'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import DatePickerField from 'components/atoms/fields/DatePickerField'
import { format } from 'date-fns'
import { useGET_studentsProfileSelectQuery } from 'redux/api/studentsApi'
import { useGET_groupSelectQuery } from 'redux/api/groupsApi'
import { gradeSelectData } from 'utils/helpers'


const ExtraFilters: FC<{hideStudentFields?: boolean}> = ({hideStudentFields = false}) => {
  const dispatch = useDispatch<AppDispatch>()
  const { t } = useTranslation()
  const reduxKey = 'kpiEvaluations'

  
  const { subject, grade_level, group, student, created_at_after, created_at_before } = formModel()
  
  const filters = {
    grade_level: useSelector((state: RootState) => state[reduxKey].tableFilters.grade_level),
    subject: useSelector((state: RootState) => state[reduxKey].tableFilters.subject),
    category: useSelector((state: RootState) => state[reduxKey].tableFilters.category),
    group: useSelector((state: RootState) => state[reduxKey].tableFilters.group),
  }
  
  return (
    <>

      <Grid item xs={5} xl={6}>
        <SelectField
          fieldProps={{ ...subject }}
          apiCall={useGET_subjectsSelectQuery}
          onChange={(value: { id: any }) => {
            dispatch(setSubject(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <DatePickerField
          sx={{ height: 45 }}
          fieldProps={{ ...created_at_after }}
          onChange={(value: Date) => {
            dispatch(setCreatedAfter(value ? format(value, 'yyyy-MM-dd') : ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>

      <Grid item xs={12} md={3}>
        <DatePickerField
          sx={{ height: 45 }}
          fieldProps={{ ...created_at_before }}
          onChange={(value: Date) => {
            dispatch(setCreatedBefore(value ? format(value, 'yyyy-MM-dd') : ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid> 

      {!hideStudentFields && <>
       <Grid item xs={2} xl={3}>
        <SelectField
            renderChildren={false}
            fieldProps={{ ...grade_level }}
            apiCall={gradeSelectData}
            onChange={(value: { id: any }) => {
              dispatch(setGradeLevel(value?.id ?? ''))
              dispatch(trackActiveFilters())
            }}
          />
      </Grid>

              
      <Grid item xs={12} md={3}>
       <SelectField
          fieldProps={{ ...group }}
          apiCall={useGET_groupSelectQuery}
          filters={{
            grade_level: filters.grade_level,
          }}
          onChange={(value: { id: any }) => {
            dispatch(setGroup(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid>

      <Grid item xs={12} md={6}>
        <SelectField
          fieldProps={{ ...student }}
          apiCall={useGET_studentsProfileSelectQuery}
          filters={{
              group: filters.group,
          }}
          onChange={(value: { id: any }) => {
            dispatch(setStudent(value?.id ?? ''))
            dispatch(trackActiveFilters())
          }}
        />
      </Grid> 
      </>}

     

    </>
  )
}
export default ExtraFilters